import Vue from 'vue'
// https://github.com/declandewet/vue-meta
import VueMeta from 'vue-meta'

Vue.use(VueMeta, {
  keyName: 'page',
});
